export default __webpack_public_path__ + "locales/pt/JavascriptSdk.json?hash=73a049fd7745e3ec817b04061c014ebb";